(function() {
  'use strict';

  const FACET_LABEL = 'Taglia';

  function getCollectionHandle() {
    const match = window.location.pathname.match(/\/collections\/([^/?]+)/);
    return match ? match[1] : null;
  }

  async function fetchCollectionProducts() {
    const handle = getCollectionHandle();
    if (!handle) return [];
    try {
      const response = await fetch(`/collections/${handle}/products.json?limit=250`);
      if (!response.ok) return [];
      const data = await response.json();
      return data.products || [];
    } catch (e) { return []; }
  }

  function getAvailableSizes(products) {
    const sizes = new Set();
    products.forEach(product => {
      product.variants.forEach(variant => {
        if (variant.available) {
          [variant.option1, variant.option2, variant.option3].forEach(opt => {
            if (opt) sizes.add(opt.trim());
          });
        }
      });
    });
    return sizes;
  }

  function getTagliaContainer() {
    for (let details of document.querySelectorAll('details')) {
      const summary = details.querySelector('summary');
      if (summary && summary.textContent.trim().includes(FACET_LABEL)) return details;
    }
    return null;
  }

  function applyFilter(availableSizes) {
    const container = getTagliaContainer();
    if (!container) return;
    container.querySelectorAll('.facets__item').forEach(item => {
      const label = item.querySelector('label');
      if (label) {
        const size = label.textContent.trim();
        item.style.display = availableSizes.has(size) ? '' : 'none';
      }
    });
  }

  async function run() {
    const products = await fetchCollectionProducts();
    const sizes = getAvailableSizes(products);
    applyFilter(sizes);
  }

  document.addEventListener('DOMContentLoaded', run);
  document.addEventListener('shopify:section:load', run);

  // Ascolta aggiornamenti AJAX di Dawn
  document.addEventListener('facets:filter:updated', run);
  window.addEventListener('popstate', run);
})();
